import { useMutation } from '@tanstack/react-query'
import { ContactFormMessagesFilterParams } from '@/types/contact-message'
import { useContactFormMessagesStore } from '@/store'
import { useBulkDeleteSuccessHandler } from './use-bulk-delete'
import { useQuery } from '@tanstack/react-query'

export const useContactFormMessages = (params: ContactFormMessagesFilterParams) => {
  const fetchContactFormMessages = useContactFormMessagesStore(state => state.fetchContactFormMessages)

  return useQuery({
    queryKey: ['contact-form-messages', params],
    queryFn: () => fetchContactFormMessages(params),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000
  })
}

export const useContactFormMessage = (id: string) => {
  const getContactFormMessage = useContactFormMessagesStore(state => state.getContactFormMessage)

  return useQuery({
    queryKey: ['contact-form-message', id],
    queryFn: () => getContactFormMessage(id),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    enabled: !!id
  })
}

export const useDeleteContactFormMessage = () => {
  const deleteContactFormMessage = useContactFormMessagesStore(state => state.deleteContactFormMessage)

  return useMutation({
    mutationFn: (id: string) => deleteContactFormMessage(id),
    onSuccess: () => {}
  })
}

export const useBulkDeleteContactFormMessages = () => {
  const bulkDeleteContactFormMessages = useContactFormMessagesStore(state => state.bulkDeleteContactFormMessages)
  const deselectAllContactFormMessages = useContactFormMessagesStore(state => state.deselectAllContactFormMessages)
  const handleBulkDeleteSuccess = useBulkDeleteSuccessHandler()

  return useMutation({
    mutationFn: (ids: string[]) => bulkDeleteContactFormMessages(ids),
    onSuccess: response => {
      deselectAllContactFormMessages()
      handleBulkDeleteSuccess(response)
    }
  })
}
